import React from "react";
import { CircularProgress } from "@mui/material";
import { TypeSender } from "../../constants/TypeSender";
import ChatSkeleton from "./ChatSkeleton/ChatSkeleton";
import FormattedText from "./FormattedText/FormattedText";
import imgBot from "../../assets/images/bot-2.png";
import AudioFeedbackControls from "./AudioFeedbackControls";

interface ChatMessageProps {
  msg: any;
  readMessage: (message: string, playbackRate: number, key: string) => void;
  pauseCurrentAudio: (key: string) => void;
  resumeCurrentAudio: (key: string) => void;
  adjustPlaybackRate: (rate: number, key: string) => void;
  activeAudio: string | null;
  isPaused: { [key: string]: boolean };
  selectedRates: number;
  isSmallScreen: boolean;
  handleFeedback: (message: any, type: string) => void;
  loadingFeedback: { [key: string]: boolean };
  feedbackGiven: { [key: string]: string };
  showDownOptions: { [key: string]: boolean };
  setShowDownOptions: React.Dispatch<
    React.SetStateAction<{ [key: string]: boolean }>
  >;
  handleSubmitFeedback: (detail: string) => void;
  setShowFeedbackModal: React.Dispatch<React.SetStateAction<boolean>>;
  showSkeleton: boolean;
}

const ChatMessage: React.FC<ChatMessageProps> = ({
  msg,
  readMessage,
  pauseCurrentAudio,
  resumeCurrentAudio,
  adjustPlaybackRate,
  activeAudio,
  isPaused,
  selectedRates,
  isSmallScreen,
  handleFeedback,
  loadingFeedback,
  feedbackGiven,
  showDownOptions,
  setShowDownOptions,
  handleSubmitFeedback,
  setShowFeedbackModal,
  showSkeleton,
}) => {
  return showSkeleton ? (
    <ChatSkeleton />
  ) : (
    <div className={`chat-message ${msg.sender === "Trixie" ? "bot" : "user"}`}>
      {msg.sender === "Trixie" && (
        <div className="bot-avatar">
          <img src={imgBot} alt="Bot Avatar" width={42} height={42} />
        </div>
      )}
      <div className="chat-message-content">
        {/\.(mp4|webm|ogg)(\?|$)/.test(msg.message) ? (
          <video controls width="300">
            <source src={msg.message} type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        ) : (
          <FormattedText text={msg.message} sender={msg.sender} />
        )}

        {msg.questions && msg.questions.length > 0 && (
          <ul>
            {msg.questions.map((question: string, qIndex: number) => (
              <li key={qIndex}>{question}</li>
            ))}
          </ul>
        )}

        {msg.sender === TypeSender["tutor"] && msg.qa_id && msg.audioText ? (
          loadingFeedback[msg.qa_id] ? (
            <CircularProgress size={10} />
          ) : (
            <AudioFeedbackControls
              activeAudio={activeAudio}
              isPaused={isPaused}
              selectedRates={selectedRates}
              isSmallScreen={isSmallScreen}
              readMessage={readMessage}
              pauseCurrentAudio={pauseCurrentAudio}
              resumeCurrentAudio={resumeCurrentAudio}
              adjustPlaybackRate={adjustPlaybackRate}
              msgAudioText={msg.audioText}
              msg={msg}
              handleFeedback={handleFeedback}
              feedbackGiven={feedbackGiven}
              showDownOptions={showDownOptions}
              setShowDownOptions={setShowDownOptions}
              handleSubmitFeedback={handleSubmitFeedback}
              setShowFeedbackModal={setShowFeedbackModal}
            />
          )
        ) : null}
      </div>
    </div>
  );
};

export default ChatMessage;
